/* eslint-disable import/no-default-export, import/order, max-lines, max-lines-per-function, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { cn } from "tailwind-variants";
import CanvaIcon from "assets/icons/canva.svg";
import "./CanvaTrigger.scss";

export default function CanvaTrigger({ onClick, ...restProps }: any) {
  return (
    <a
      {...restProps}
      className={cn("canva-trigger scope-24f6a37c", restProps.className)}
      href="#"
      onClick={e => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) onClick();
      }}
      data-testid="canva-trigger"
    >
      <CanvaIcon className="canva-trigger__icon scope-24f6a37c" data-testid="canva-trigger-icon" />
    </a>
  );
}
